@if (mode === 'select') {
  <mat-form-field tourAnchor="tankTypeSelect" [class]="inputClass">
    <mat-label>Tank type</mat-label>
    <mat-select [disabled]="disabled"
                #matSelect
                [errorStateMatcher]="errorStateMatcher"
                [placeholder]="placeholder"
                [(ngModel)]="value"
                (selectionChange)="onChange($event.value)"
                (blur)="onTouched()">
      @if (hasEmptyOption) {
        <mat-option [value]="false">{{ emptyOptionLabel }}</mat-option>
      }
      @for (type of types; track type) {
        <mat-option [value]="type">{{ tankTypes[type] | translate }}</mat-option>
      }
    </mat-select>
    <mat-error>
      <app-validation-error [errors]="ngControl.errors"></app-validation-error>
    </mat-error>
  </mat-form-field>
}

@if (mode === 'radioIcons') {
  <mat-radio-group class="radio-icons"
                   [class]="inputClass"
                   [formControl]="ngControl.control"
                   [errorStateMatcher]="errorStateMatcher"
                   (change)="onChange($event.value)">
    @for (icon of radioIcons | sortBy:'disabled' :'desc'; track icon.type) {
      <div class="radio-icon-wrapper flex-column flex-grow-1 align-v-center radio-button-{{ tankTypes[icon.type] | lowercase }}">
        <mat-radio-button name="radio-button-{{ icon.type }}"
                          class="radio-button-{{ tankTypes[icon.type] | lowercase }}"
                          [value]="icon.type"
                          [disabled]="icon.disabled"
                          [matTooltip]="tankTypes[icon.type] | translate">
          <i class="icon icon-{{ tankTypes[icon.type] | lowercase }}"></i>
        </mat-radio-button>
        <div class="radio-button-text">
          {{ tankTypes[icon.type] | lowercase | titlecase }}
        </div>
      </div>
    }
  </mat-radio-group>
}

@if (mode === 'radioLabels') {
  <mat-radio-group
    class="primary"
    (change)="onChange($event.value)"
    [class]="inputClass"
    [(ngModel)]="value">
    @if (hasEmptyOption) {
      <mat-radio-button [value]="false">{{ emptyOptionLabel }}</mat-radio-button>
    }
    @for (type of types; track type) {
      <mat-radio-button [value]="type">
        {{ tankTypes[type] | translate }}
      </mat-radio-button>
    }
  </mat-radio-group>
}
